import { useFetchCountries } from './api';

// Elsewhere, most `en` translations echo the English query back unchanged.
const TRANSLATED_MARKETS = ['FR', 'KR', 'JP', 'GLOBAL'];

export const translationCSVColumn = {
    accessor: ({ translations }) => translations?.en || '',
    label: 'translation (en)',
};

export default function useShowTranslations({ rows, countries }) {
    const { data: allCountries } = useFetchCountries();
    if (!rows?.some(({ translations }) => translations?.en)) return false;
    return (countries || []).some((countryId) =>
        TRANSLATED_MARKETS.includes(
            allCountries?.find(({ id }) => id === countryId)?.text_id,
        ),
    );
}
